<template>
  <div>
    <b-navbar toggleable="md" type="dark" variant="info">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

      <b-navbar-brand href="#">Salesianer</b-navbar-brand>

      <b-collapse is-nav id="nav_collapse">

        <b-navbar-nav> 
          <b-nav-item  href="#/dashboard">{{ $t("menu.dashboard") }}</b-nav-item>
          
          <b-nav-item-dropdown :text='$t("menu.requests")' v-if="$rights.is_not_guest()">
            <b-dropdown-item @click="request_new_product">{{ $t("menu.request_new_product") }}</b-dropdown-item>
            <b-dropdown-item @click="request_new_category">{{ $t("menu.request_new_category") }}</b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item href="#/my-stocks">{{$t("menu.my_stocks") }}</b-nav-item>
          <b-nav-item href="#/my-orders">{{$t("menu.my_orders") }}</b-nav-item>
          
          <b-nav-item-dropdown :text='$t("menu.administration") + get_notification_html()' v-if="$rights.is_admin_or_power_user()">
            <b-dropdown-item href="#/users"  v-if="$rights.is_admin_or_power_user()">{{$t("menu.users") }}</b-dropdown-item>
            <b-dropdown-item href="#/factories" v-if="$rights.is_admin()">{{$t("menu.factories") }}</b-dropdown-item>
            <b-dropdown-divider v-if="$rights.is_admin()"/>

            <b-dropdown-item href="#/product-categories"  v-if="$rights.is_admin()">
              {{$t("menu.product_categories") }}
              <span v-if="unapproved_categories_count>0" class="badge badge-danger badge-pill pull-right">{{unapproved_categories_count}}</span>
            </b-dropdown-item>
            <b-dropdown-item href="#/products" v-if="$rights.is_admin()">
              {{$t("menu.products") }}
              <span v-if="unapproved_products_count>0" class="badge badge-danger badge-pill pull-right">{{unapproved_products_count}}</span>
            </b-dropdown-item>

            <b-dropdown-divider v-if="$rights.is_admin()"/>
            <b-dropdown-item href="#/settings" v-if="$rights.is_admin()">{{$t("menu.settings") }}</b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown :text="$t('menu.reports')" v-if="$rights.is_admin()">
            <b-dropdown-item href="#/reports-orders">{{$t("menu.orders") }}</b-dropdown-item>
            <b-dropdown-item href="#/reports-lazy-users">{{$t("menu.lazy_users") }}</b-dropdown-item>
            <b-dropdown-item href="#/reports-last-stock-update">{{$t("menu.last_stock_update") }}</b-dropdown-item>
            <b-dropdown-item href="#/report-unordered-products">{{$t("menu.unordered_products") }}</b-dropdown-item>
            
          </b-nav-item-dropdown>
          <b-nav-item href="#/imports" v-if="$rights.is_admin()" >{{$t("menu.imports") }}</b-nav-item>
        </b-navbar-nav>
      
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown :text="$t('menu.lang')" right>
            <b-dropdown-item @click="change_language('en')">English</b-dropdown-item>
            <b-dropdown-item @click="change_language('de')">Deutsch</b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown :text="$t('menu.my_profile')" right>
            <b-dropdown-item @click="show_change_password()">{{$t('menu.change_password')}}</b-dropdown-item>
            <b-dropdown-divider/>
            <b-dropdown-item @click="logout()">{{ $t("menu.log_out") }}</b-dropdown-item>
          </b-nav-item-dropdown>

        </b-navbar-nav>

      </b-collapse>
    </b-navbar>


    <product-dialog ref="product_dialog" />
    <category-dialog ref="category_dialog" />
    <change-password-dialog ref="change_pass_dialog" />

  </div>
</template>

<script>
import Vue from "vue";
import ElementUI from "element-ui";

import settings from "./../backend/LocalSettings";
import LocalSettings from './../backend/LocalSettings';
import ProductDialog from "./../views/dialogs/ProductDialog";
import CategoryDialog from "./../views/dialogs/CategoryDialog";
import ChangePasswordDialog from "./../views/dialogs/ChangePasswordDialog";

import localeen from "element-ui/lib/locale/lang/en"
import localede from "element-ui/lib/locale/lang/de"
import { EventBus } from '../backend/EventBus.js';


export default {
  name: "mainmenu",
  components: {
    "product-dialog": ProductDialog,
    "category-dialog": CategoryDialog,
    'change-password-dialog': ChangePasswordDialog
  },
  props: [ "selected" ],
  data () {
    return {
      show: false,
      email: "",
      password: "",
      unapproved_products_count: 0,
      unapproved_categories_count: 0,
    }
  },
  methods: {
    request_new_product: function(){
      this.$refs.product_dialog.show_me ( null, 1 );
    },
    request_new_category: function(){
      this.$refs.category_dialog.show_me ( null, 1 );
    },
    logout: function() {
      settings.logout(this.$rights);
      this.$router.push("/");
    },
    change_language: function( lang_name ) {
      window.localStorage.setItem('locale', lang_name);
      this.$i18n.locale = lang_name;
    },
    show_change_password: function(){
      this.$refs.change_pass_dialog.show_me( -1 );
    },
    set_menu_notification_info( UnapprovedProductsCount, UnapprovedCategoriesCount)
    {
      this.unapproved_products_count   = parseInt( UnapprovedProductsCount   );
      this.unapproved_categories_count = parseInt( UnapprovedCategoriesCount );
    },
    get_notification_html: function(){
      var count = Math.max( this.unapproved_products_count, this.unapproved_categories_count);
      if( count > 0 )
        return `<span class='badge badge-danger' style='margin-left:5px'>${count}</span>`;
      else
        return '';
    }
  },
  mounted: function() {
    EventBus.$on('on_menu_notification_change', (products_count, categories_count) => {
      this.set_menu_notification_info( products_count, categories_count );
    });
  }
};
</script>

<style lang="less" scoped>
  
</style>
